import { render } from "./boardGamsi.vue?vue&type=template&id=907cd920&ts=true"
import script from "./boardGamsi.vue?vue&type=script&lang=ts&config=true"
export * from "./boardGamsi.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__